export default __webpack_public_path__ + "static/media/business.9aa56f57.jpg";